import playgroundsmanager from "../../../../assets/images/docs/playgrounds/playgroundsmanager.png";
import directorylisting from "../../../../assets/images/docs/playgrounds/directorylisting.png";
import playgroundportal from "../../../../assets/videos/docs/playgrounds/portal.mp4";
import * as React from 'react';
export default {
  playgroundsmanager,
  directorylisting,
  playgroundportal,
  React
};